export var httpHandlerOptions = {};
//# sourceMappingURL=httpHandlerOptions.js.map